import tracking from 'dibs-tracking';
import { getPromoCreative } from '../../helpers/getPromoCreative';

function trackFeaturedImpressions(items) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: items.map((item, index) => {
            const url = item?.linkData?.path || '';
            const position = index + 1;
            return {
                id: 'five-brick-module',
                name: 'Five Brick Module',
                creative: getPromoCreative(url),
                position: position,
            };
        }),
    });
}

function trackFeaturedClick(item, index) {
    const url = item?.linkData?.path || '';
    const position = index + 1;
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: 'five-brick-module',
                name: 'Five Brick Module',
                creative: getPromoCreative(url),
                position: position,
            },
        ],
    });
}

export { trackFeaturedImpressions, trackFeaturedClick };
